import * as ReactService from "@intech/react-service";
import { ArquivoUploadEntidade } from "../entidades/ArquivoUploadEntidade";

class Documento extends ReactService.BaseService {
  constructor() {
    super("Documento");
  }

  Buscar = (oidPasta: number) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `porPasta/${oidPasta}`);

  BuscarPorPlanoPasta = (cdPlano: string, oidPasta: number, criteria: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarPorPlanoPasta/${cdPlano}/${oidPasta}/${criteria}`);

  BuscarTodosPorPasta = (oidPasta: number, criteria: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarTodosPorPasta/${oidPasta}/${criteria}`);

  BuscarPorOidDocumento = (oidDocumento: number) =>
    this.CreateRequest<ArquivoUploadEntidade>(ReactService.RequestType.GET, `BuscarPorOidDocumento/${oidDocumento}`);

  Download = (OID_DOCUMENTO: number) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `Download/${OID_DOCUMENTO}`, null, ReactService.ResponseType.Blob);

  EnviarDocumento = (OID_DOCUMENTO: number) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `enviarDocumento/${OID_DOCUMENTO}`);

}

export const DocumentoService = new Documento();
